import { createContext } from 'react'
import type { Rule } from './Validations'
import type { FormMetadata } from '.'

export interface IFormContext {
  form: Record<string, string | boolean | number | string[]>
  hasFormInitialized: boolean
  errors: Record<string, string>
  setFormValue: (
    key: string,
    value: string | boolean | number | string[],
    isUserAction: boolean
  ) => void
  setFormArrayValue: (
    key: string,
    value: string | boolean | undefined,
    isUserAction: boolean
  ) => void
  removeFormArrayValue: (key: string, value: string | boolean, isUserAction: boolean) => void
  deleteFormValue: (key: string, isUserAction: boolean) => void
  setFormValidation: (key: string, validations: Array<ReturnType<Rule>>) => void
  setFormMetaData: (metaData: FormMetadata) => void
  setInputInitialized: (key: string, isInitialized: boolean) => void
}
export const FormContext = createContext<IFormContext>({
  form: {},
  hasFormInitialized: false,
  errors: {},
  setFormValue: () => ({}),
  setFormArrayValue: () => ({}),
  removeFormArrayValue: () => ({}),
  deleteFormValue: () => ({}),
  setFormValidation: () => ({}),
  setFormMetaData: () => ({}),
  setInputInitialized: () => ({}),
})

export interface IFieldsetContext {
  isInsideFieldset: boolean
  inputs: string[]
}
export const FieldsetContext = createContext<IFieldsetContext>({
  isInsideFieldset: false,
  inputs: [],
})
